import { IconSVG } from 'atto-svgs';

import { colors, darkThemeSelector, shadows, styled } from '../../stitches.config';

const BaseSVG = styled('svg', {
  display: 'inline-block',
  flexGrow: 0,
  flexShrink: 0,
  width: '100%',
});
BaseSVG.displayName = 'BaseSVG';

const Container = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '$4',
  background: colors.white,
  boxShadow: shadows.manufacturerLight,
  color: colors.gray600,
  flexShrink: 0,

  [darkThemeSelector]: {
    boxShadow: shadows.manufacturerDark,
  },

  variants: {
    size: {
      small: {
        borderRadius: '$10',
        width: '$20',
        height: '$20',
      },
      medium: {
        borderRadius: '$16',
        width: '$32',
        height: '$32',
        padding: '$6',
      },
      large: {
        borderRadius: '$20',
        width: '$40',
        height: '$40',
      },
    },
  },
});
Container.displayName = 'Container';

export interface ClientIconProps {
  className?: string;

  /**
   * Sets the size of the component.
   */
  size?: 'large' | 'medium' | 'small';
}

export function ClientIcon({ className, size = 'medium', ...remaining }: ClientIconProps) {
  return (
    <Container className={className} size={size} {...remaining}>
      <BaseSVG width={12} height={12} as={IconSVG.Client} />
    </Container>
  );
}
